/* eslint-disable no-unused-vars */
import { Grid, CircularProgress } from "@mui/material";
import PDialog from "../../../components/pos/PDialog";
import PSelect from "../../../components/pos/PSelect";
import PText from "../../../components/pos/PText";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";

export default function InventoryAdjustmentSingleItem(props) {
  const { t } = useTranslation();
  const translate = t;
  const [productObject, setProductObject] = useState(null);
  const [newStock, setNewStock] = useState(0);
  const [reason, setReason] = useState();
  const [descerption, setDescription] = useState();
  const [reasonOptions, setReasonOptions] = useState();
  const [openWindow, setOpenWindow] = useState(false);
  const [reasonError, setReasonError] = useState();
  const [descriptionError, setDescriptionError] = useState(null);
  const [stockError, setStockError] = useState(null);
  const [mode, setMode] = useState("create");
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");
  const [stockChangeType, setStockChangeType] = useState({
    name: "Stock Add",
    code: "STOCK_ADD",
  });
  const [stockChangeTypeOptions, setStockChangeTypeOptions] = useState([
    {
      name: "Opening Stock",
      code: "OPENING_STOCK",
    },
    {
      name: "Stock Add",
      code: "STOCK_ADJUSTMENT_ADD",
    },
    {
      name: "Stock Remove",
      code: "STOCK_REMOVE",
    },
  ]);

  useEffect(() => {
    setReasonOptions([
      { name: "Opening Stock", code: "Opening Stock" },
      { name: "Damage", code: "Damage" },
      { name: "Adjustment", code: "Adjustment" },
      { name: "Return", code: "Return" },
      { name: "Stock Take", code: "Stock Take" },
      { name: "Others", code: "Others" },
    ]);
  }, []);

  props.biRef.singleItemAdjustment = {
    showInventoryAdjustmentSingleItem: showInventoryAdjustmentSingleItem,
  };

  function showInventoryAdjustmentSingleItem(productId) {
    populateProduct(productId);
    setReason(null);
    setDescription(null);
    setNewStock(0);
    setDescriptionError(null);
    setReasonError(null);
    setStockError(null);
  }

  async function populateProduct(productId) {
    try {
      let { data } = await API.get("/api/v1/product/" + productId);
      setProductObject(data);
      setOpenWindow(true);
    } catch (err) {
      props.showMessage(
        "error",
        translate("Not able to retrive purchase order data from server")
      );
    }
  }
  function onCloseWindow() {
    setOpenWindow(false);
  }
  function onDelete() {}

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  async function onSave() {
    if (validate()) {
      var payload = createPayload();
      try {
        showProgress(true, "Saving");
        let result = await API.post("/api/v1/inventory/adjustment", payload);
        props.showMessage("success", translate("Saved Successfully"));
        setOpenWindow(false);
        showProgress(false, "Saving");
      } catch (err) {
        showProgress(false, "Saving");
        props.showMessage(
          "error",
          translate("Not able to Save Stock Adjustment")
        );
      }
    }
  }

  function validate() {
    let flag = true;
    if (!reason || reason === "") {
      setReasonError(translate("Reason is Required"));
      flag = false;
    }
    if (!descerption || descerption === "") {
      setDescriptionError(translate("Description is Required"));
      flag = false;
    }
    if (!newStock || newStock === "") {
      setStockError(translate("New stock is Required"));
      flag = false;
    }
    return flag;
  }

  function createPayload() {
    let saveObject = Object.create(null);
    saveObject["stockChangeTypeString"] = stockChangeType.name;
    saveObject["stockChangeTypeCode"] = stockChangeType.code;
    saveObject["description"] = descerption;
    saveObject["orderId"] = "AUTO";
    saveObject["status"] = "POSTED";
    let selectedItems = [];
    let itemsObject = Object.create(null);
    itemsObject["productBean"] = productObject;
    itemsObject["currentQuantity"] = productObject.stockBean.currentStock;
    itemsObject["updatedQuantity"] = newStock;
    itemsObject["reasonCode"] = reason.code;
    itemsObject["reason"] = reason.name;
    itemsObject["barcode"] = null;
    selectedItems.push(itemsObject);
    saveObject["adjustmentItemList"] = selectedItems;
    return saveObject;
  }
  const content = (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6}>
        <table width="100%">
          <tbody>
            <tr>
              <td>{translate("Item Code")}</td>
              <td>{productObject ? productObject.code : null}</td>
            </tr>
            <tr>
              <td>{translate("Vendor")}</td>
              <td>{productObject ? productObject.vendorBean.name : null}</td>
            </tr>
            <tr>
              <td>{translate("Current Stock")}</td>
              <td>
                {productObject ? productObject.stockBean.currentStock : 0}
              </td>
            </tr>
            <tr>
              <td>{translate("Reason")}</td>
              <td>
                <PSelect
                  options={reasonOptions}
                  value={reason}
                  errorMessage={reasonError}
                  onChange={(event, newValue) => {
                    setReason(newValue);
                    setReasonError(null);
                  }}
                ></PSelect>
              </td>
            </tr>
            <tr>
              <td>{translate("Change Type")}</td>
              <td>
                <PSelect
                  options={stockChangeTypeOptions}
                  value={stockChangeType}
                  onChange={(event, newValue) => setStockChangeType(newValue)}
                ></PSelect>
              </td>
            </tr>
          </tbody>
        </table>
      </Grid>
      <Grid item xs={12} sm={6}>
        <table width="100%">
          <tbody>
            <tr>
              <td>{translate("Item Name")}</td>
              <td>{productObject ? productObject.name : null}</td>
            </tr>
            <tr>
              <td>{translate("Department")}</td>
              <td>{productObject ? productObject.deptBean.name : null}</td>
            </tr>
            <tr>
              <td>{translate("New Stock")}</td>
              <td>
                <PText
                  type="number"
                  value={newStock}
                  error={stockError}
                  onChange={(e) => {
                    setNewStock(e.target.value);
                    setStockError(null);
                  }}
                ></PText>
              </td>
            </tr>
            <tr>
              <td>{translate("Reason description")}</td>
              <td>
                <PText
                  value={descerption}
                  error={descriptionError}
                  onChange={(e) => {
                    setDescription(e.target.value);
                    setDescriptionError(null);
                  }}
                ></PText>
              </td>
            </tr>
          </tbody>
        </table>
      </Grid>
    </Grid>
  );
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={translate("Stock Adjustment")}
          maxWidth={"md"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          onDelete={onDelete}
          mode={mode}
        ></PDialog>
      )}
            {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}
    </div>
  );
}
